import { server_connection } from 'config';

export const GET_CONTENT_LABEL_LIST = '[CONTENT_LABEL APP] GET CONTENT LABEL LIST';

export function getContentLabelList() {
    return (dispatch, getState) => {
        return fetch(server_connection + '/content_label/list')
            .then((response) => response.json())
            .then((labelList) => {
                return dispatch({
                    type: GET_CONTENT_LABEL_LIST,
                    payload: labelList,
                });
            });
    }
};


// WEBPACK FOOTER //
// src/main/content/content_label/store/actions/content_label.actions.js